export enum RoutingPath {
  Login = "login",
  Dashboard = "dashboard",
  ClientsAndAccounts = "clients-and-accounts",
  Quotations = "quotations",
  BookingManagement = "booking-management",
  Collections = "collections",
  Disbursement = "disbursement",
  Trading = "trading",
  Messages = "messages",
  Products = "products",
  ModelManagement = "model-management",
  FinancialInstitutions = "financial-institution",
  Intermediary = "intermediary",
  Advisor = "advisor",
  Insurer = "insurer",
  AccountManager = "account-manager",
  Communication = "communication",
  ExchangeFunds = "exchange-funds",
  Report = "report",
  AccountOverview = "account-overview",
  FundOverview = "fund-overview",
  Dividend = "dividend",
  Rebalance = "rebalance",
  Settings = "settings",
  NotFound = "not-found",
}
